import * as C from "../constants/contactConstants";

export const contactCreateReducer = (state = {}, action) => {
  switch (action.type) {
    case C.CONTACT_CREATE_REQUEST:
      return { loading: true };

    case C.CONTACT_CREATE_SUCCESS:
      return {
        loading: false,
        success: true,
        contact: action.payload,
      };

    case C.CONTACT_CREATE_FAIL:
      return {
        loading: false,
        error: action.payload,
      };

    case C.CONTACT_CREATE_RESET:
      return {};

    default:
      return state;
  }
};

export const contactListReducer = (state = { contacts: [] }, action) => {
  switch (action.type) {
    case C.CONTACT_LIST_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case C.CONTACT_LIST_SUCCESS:
      return {
        loading: false,
        contacts: action.payload || [],
      };

    case C.CONTACT_LIST_FAIL:
      return {
        loading: false,
        error: action.payload,
        contacts: [],
      };

    default:
      return state;
  }
};

export const contactDetailsReducer = (state = { contact: {} }, action) => {
  switch (action.type) {
    case C.CONTACT_DETAILS_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case C.CONTACT_DETAILS_SUCCESS:
      return {
        loading: false,
        contact: action.payload,
      };

    case C.CONTACT_DETAILS_FAIL:
      return {
        loading: false,
        error: action.payload,
        contact: {},
      };

    default:
      return state;
  }
};

export const contactDeleteReducer = (state = {}, action) => {
  switch (action.type) {
    case C.CONTACT_DELETE_REQUEST:
      return { loading: true };

    case C.CONTACT_DELETE_SUCCESS:
      return {
        loading: false,
        success: true,
      };

    case C.CONTACT_DELETE_FAIL:
      return {
        loading: false,
        error: action.payload,
      };

    case C.CONTACT_DELETE_RESET:
      return {};

    default:
      return state;
  }
};

export const contactUpdateStatusReducer = (state = {}, action) => {
  switch (action.type) {
    case C.CONTACT_UPDATE_STATUS_REQUEST:
      return { loading: true };

    case C.CONTACT_UPDATE_STATUS_SUCCESS:
      return {
        loading: false,
        success: true,
        contact: action.payload,
      };

    case C.CONTACT_UPDATE_STATUS_FAIL:
      return {
        loading: false,
        error: action.payload,
      };

    case C.CONTACT_UPDATE_STATUS_RESET:
      return {};

    default:
      return state;
  }
};

export const contactContentDetailsReducer = (
  state = { content: {} },
  action,
) => {
  switch (action.type) {
    case C.CONTACT_CONTENT_DETAILS_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case C.CONTACT_CONTENT_DETAILS_SUCCESS:
      return {
        loading: false,
        content: action.payload,
      };

    case C.CONTACT_CONTENT_DETAILS_FAIL:
      return {
        loading: false,
        error: action.payload,
        content: {},
      };

    default:
      return state;
  }
};

export const contactContentUpdateReducer = (state = {}, action) => {
  switch (action.type) {
    case C.CONTACT_CONTENT_UPDATE_REQUEST:
      return { loading: true };

    case C.CONTACT_CONTENT_UPDATE_SUCCESS:
      return {
        loading: false,
        success: true,
        content: action.payload,
      };

    case C.CONTACT_CONTENT_UPDATE_FAIL:
      return {
        loading: false,
        error: action.payload,
      };

    case C.CONTACT_CONTENT_UPDATE_RESET:
      return {};

    default:
      return state;
  }
};
